import { Trash2, Pencil, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useState } from "react";
import ModifyPolygonSvg from "../../icons/modify_polygon.svg?react";

interface BoundaryItemProps {
  id: string;
  name: string;
  area: number;
  selected: boolean;
  onEdit: (id: string, name: string) => void;
  onDelete: (id: string) => void;
  onSelect: (id: string) => void;
}
export const BoundaryItem = (props: BoundaryItemProps) => {
  const [editing, setEditing] = useState<boolean>(false);
  const [name, setName] = useState<string>(props.name);

  const humanizeArea = (areaSqm: number) => {
    const areaSqkm = areaSqm / 1000000;
    if (areaSqkm < 1)
      return `${areaSqm.toLocaleString(undefined, {
        maximumFractionDigits: 1,
      })} m2`;
    return `${areaSqkm.toLocaleString(undefined, {
      maximumFractionDigits: 1,
    })} km2`;
  };

  return (
    <div
      className={`h-16 flex flex-row items-center gap-4 px-3 rounded-lg border cursor-pointer ${
        props.selected ? "bg-primary/10 border-primary" : "hover:bg-muted"
      }`}
      onClick={() => props.onSelect(props.id)}
    >
      <div className="flex items-center justify-center">
        <ModifyPolygonSvg className="size-5" fill="currentColor" />
      </div>
      <div className="flex flex-col flex-1 min-w-0">
        {editing ? (
          <Input
            value={name}
            maxLength={200}
            className="h-7 text-sm"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            onChange={(e) => {
              e.stopPropagation();
              setName(e.target.value);
              props.onEdit(props.id, e.target.value);
            }}
          />
        ) : (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="text-sm truncate">{props.name}</span>
            </TooltipTrigger>
            <TooltipContent>{props.name}</TooltipContent>
          </Tooltip>
        )}
        <span className="text-xs text-muted-foreground">
          {humanizeArea(props.area)}
        </span>
      </div>
      <div className="flex ml-auto">
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setEditing(!editing);
          }}
        >
          {!editing ? <Pencil className="size-4" /> : <Save className="size-4" />}
        </Button>
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            props.onDelete(props.id);
          }}
        >
          <Trash2 className="size-4" />
        </Button>
      </div>
    </div>
  );
};
